<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseId"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId"
                    >{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in order_status" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                <a-select v-model="queryParam.transportStatus" :allowClear="true">
                  <a-select-option v-for="type in delivery_status" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.transportName" :allowClear="true">
                  <a-select-option v-for="type in delivery_company" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="快递单号" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.transportNo" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="客户姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户联系方式">
                <a-input v-model.trim="queryParam.clientPhone" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item label="客户地址" style="margin-left: 26px">
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                      <a-select-option
                        v-for="type in selectAllProvince"
                        :title="type.provinceName"
                        :key="type.provinceCode"
                        >{{ type.provinceName }}</a-select-option
                      >
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.cityId" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.countyId" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.clientAddress" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="配件类型" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.accessoryType" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="配件名称" style="margin-left: 30px">
                <a-input v-model.trim="queryParam.accessoryName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="配件型号" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.accessoryCategory" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="配件规格" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.accessorySpecification" />
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="配件状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                  <a-select v-model="queryParam.accessoryStatus" :allowClear="true">
                    <a-select-option value="0" title="未发货"> 未发货 </a-select-option>
                    <a-select-option value="1" title="已作废"> 已作废 </a-select-option>
                    <a-select-option value="2" title="已退回"> 已退回 </a-select-option>
                    <a-select-option value="3" title="已发货"> 已发货 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="发货人" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.sendUser" />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24" v-if="showEntrepot">
                <a-form-item label="发货仓库" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-select
                    showSearch
                    optionFilterProp="children"
                    :filterOption="filterOption"
                    v-model="queryParam.repositoryId"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in getselectstoreList" :title="type.storeName" :key="type.storeId"
                      >{{ type.storeName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-row :gutter="24">
                  <a-form-item style="margin-left: 39px">
                    <a-col :md="6" :sm="24">
                      <a-select v-model="queryParam.timeType">
                        <a-select-option value="1" title="建单时间"> 建单时间 </a-select-option>
                        <a-select-option value="2" title="配件申请时间"> 配件申请时间 </a-select-option>
                        <a-select-option value="3" title="发货时间"> 发货时间 </a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :md="18" :sm="24">
                      <a-range-picker
                        :show-time="{
                          hideDisabledOptions: true,
                          defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                        }"
                        format="YYYY-MM-DD HH:mm:ss"
                        :placeholder="['开始时间', '结束时间']"
                        style="width: 100%"
                        @change="onChangerangepicker"
                        v-model="queryParam.searchTime"
                      />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
            </a-row>
          </div>
          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
              <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
              <a-button style="margin-left: 8px" type="primary" v-if="exportPartsOrder" @click="exceptExcel"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>

          <a-divider />
          <!--    表格内容-->
          <s-table size="default" ref="table" :columns="columns" :data="loadData" bordered :scroll="{ x: 3500 }">
            <span slot="action" slot-scope="text, record" style="white-space: nowrap">
              <a @click="detailsView(record)">查看</a>
              <a-divider type="vertical" />
              <a @click="fittingEdit(record)">编辑</a>
              <a-divider type="vertical" v-if="record.accessoryStatus == '已发货'" />
              <a-popconfirm
                title="是否要作废配件？"
                @confirm="partsObsolete(record.id)"
                v-if="record.accessoryStatus == '已发货'"
              >
                <a>作废</a>
              </a-popconfirm>
              <a-divider
                type="vertical"
                v-if="record.accessoryStatus != '已作废' && record.accessoryStatus != '已退回'"
              />
              <a
                @click="partsReturn(record)"
                v-if="record.accessoryStatus != '已作废' && record.accessoryStatus != '已退回'"
                >退回</a
              >
              <a-divider type="vertical" v-if="record.accessoryStatus == '未发货' && sendOrder" />
              <a v-if="record.accessoryStatus == '未发货' && sendOrder" @click="goodsDeliver(record)">发货</a>
              <a-divider type="vertical" v-if="showRepertory" />
              <a v-if="showRepertory" @click="inventoryView(record)">查看库存</a>
            </span>
            <span slot="transport" slot-scope="text, record">
              <a @click="gettransport(record)">{{ record.transportNo }}</a>
            </span>
            <span slot="storeName" slot-scope="text, record">
              <a-popover>
                <template slot="content" v-for="item in record.principalList">
                  <p>姓名:{{ item.name }} 联系方式:{{ item.phone }}</p>
                </template>
                <a class="hover">{{ record.storeName }}</a>
              </a-popover>
            </span>
          </s-table>
        </a-form>
      </div>
      <a-modal title="配件退回" style="top: 20px" v-model="accessoriesReturnidle" @ok="addaccessoriesReturn">
        <a-form :form="formaccessoriesReturn">
          <a-form-item style="display: none">
            <a-input v-decorator="['orderAccessoryId']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
            <a-date-picker
              v-model="accessoriesitem"
              style="width: 100%"
              @change="onChangeaccessories"
              format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
            <a-select
              v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
              :allowClear="true"
            >
              <a-select-option v-for="type in delivery_company" :key="type.dictValue"
                >{{ type.dictLabel }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
            <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal v-model="disable" @ok="addAccessories()" @cancel="cancelAccessories" title="配件" :width="900">
        <a-form :form="formaccessories">
          <a-row>
            <a-col :span="12">
              <a-form-item style="display: none">
                <a-input v-decorator="['id']" />
              </a-form-item>
              <a-form-item style="display: none">
                <a-input v-decorator="['transportId']" />
              </a-form-item>
              <a-form-item style="display: none">
                <a-input v-decorator="['accessoryId']" />
              </a-form-item>
              <a-form-item style="display: none">
                <a-input v-decorator="['repositoryId']" />
              </a-form-item>
              <a-form-item style="display: none">
                <a-input v-decorator="['orderId']" />
              </a-form-item>
              <a-form-item label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input
                  disabled="disabled"
                  v-decorator="['accessoryName', { rules: [{ required: true, message: '填写配件信息!' }] }]"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件单价">
                <a-input
                  disabled="disabled"
                  v-decorator="['price', { rules: [{ required: true, message: '填写配件单价!' }] }]"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input-number
                  style="width: 100%"
                  v-decorator="['accessoryNum', { rules: [{ required: true, message: '填写数量!' }] }]"
                  @change="accessoryNumChange"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总金额">
                <a-input
                  disabled="disabled"
                  v-decorator="['totalAmount', { rules: [{ required: true, message: '配件总金额!' }] }]"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货仓库">
                <a-input
                  disabled="disabled"
                  v-decorator="['storeName', { rules: [{ required: true, message: '发货仓库!' }] }]"
                />
              </a-form-item>
              <a-divider orientation="left"></a-divider>
              <a-checkbox :labelCol="labelCol" :wrapperCol="wrapperCol" :checked="showh" @change="onChangeinfo"
                >物流信息
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row v-if="showh">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
                <a-date-picker v-model="time_list" style="width: 100%" @change="onChangeT" format="YYYY-MM-DD" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
                <a-select
                  v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in delivery_company" :key="type.dictValue"
                    >{{ type.dictLabel }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
                <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货人">
                <a-input v-decorator="['sendUser']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货人">
                <a-input v-decorator="['receiveUser']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input v-decorator="['remark']" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="delivergoodsible" @ok="adddelivergoods()" title="发货" :width="900">
        <a-form :form="formdelivergoods">
          <a-row>
            <a-col :span="12">
              <a-form-item style="display: none">
                <a-input v-decorator="['id']" />
              </a-form-item>
              <a-form-item style="display: none">
                <a-input v-decorator="['orderId']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
                <a-date-picker v-model="sendTime" style="width: 258px" @change="onChangesendTime" format="YYYY-MM-DD" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
                <a-select
                  v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in delivery_company" :key="type.dictValue"
                    >{{ type.dictLabel }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
                <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">
                <a-checkbox @change="checkboxchange" v-decorator="['isMainbool', { valuePropName: 'checked' }]">
                  重要</a-checkbox
                >
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货人">
                <a-input v-decorator="['sendUser']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货人">
                <a-input v-decorator="['receiveUser']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input v-decorator="['remark']" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="transportble" :footer="null" title="快递物流信息">
        <a-form :form="form" v-if="transportInfo">
          <a-steps progress-dot :current="transportInfo.length" direction="vertical" style="width: 100%">
            <a-step
              v-for="(type, index) in transportInfo"
              :key="index"
              :title="type.ftime"
              :description="type.context"
              style="width: 90%"
            />
          </a-steps>
        </a-form>
      </a-modal>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
      <edit-order-model1 v-else ref="editorder"></edit-order-model1>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import pick from 'lodash.pick'
import { checkPermission } from '@/utils/permissions'
import {
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getList,
  getOrderDetail,
  getfinddictAll,
} from '@/api/order/orderList'
import {
  getselectCombox,
  getqueryEnterpriseAccessoryPrice,
  getqueryEnterpriseAccessory,
  getqueryEnterpriseStock,
} from '@/api/order/NewlyaddedOrderList'
import {
  getAccessoryOrderlist,
  getselectstore,
  getdeliverGoods,
  getAccessoryNumber,
  addOrderAccessory,
  getAccessoryExcept,
} from '@/api/order/PartsOrder'
import { getreturnOrderAccessory, getinvalidOrderAccessory, getTransportInfo } from '@/api/order/editorder'
import NoAuthority from '../enterprise/NoAuthority'
import { getDictMap } from '../../utils/dict'
import { STable } from '@/components'
import moment from 'moment'
export default {
  name: 'PartsOrder',
  components: {
    STable,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    NoAuthority,
    // 注册弹框组件
  },
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      formaccessories: this.$form.createForm(this),
      formdelivergoods: this.$form.createForm(this),

      time_type: [],
      transportInfo: [],
      // 发货仓库,
      queryEnterpriseStock: [],
      // 配件信息,
      EnterpriseAccessory: [],
      parts: {},
      transportble: false,
      accessoriesitem: '',
      Ifstatus: 0,
      delivergoodsible: false,
      accessoriesReturnidle: false,
      formaccessoriesReturn: this.$form.createForm(this),
      showh: false,
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center',
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },

        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '配件类型',
          dataIndex: 'accessoryType',
          align: 'center',
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align: 'center',
        },
        {
          title: '配件型号',
          dataIndex: 'accessoryCategory',
          align: 'center',
        },
        {
          title: '配件规格',
          dataIndex: 'accessorySpecification',
          align: 'center',
        },
        {
          title: '配件状态',
          dataIndex: 'accessoryStatus',
          align: 'center',
        },
        {
          title: '数量',
          dataIndex: 'accessoryNum',
          align: 'center',
        },
        {
          title: '发货仓库',
          dataIndex: 'storeName',
          scopedSlots: { customRender: 'storeName' },
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '收货地址',
          dataIndex: 'address',

          width: '300px',
        },
        {
          title: '快递公司',
          dataIndex: 'transportName',
          align: 'center',
        },
        {
          title: '快递单号',
          dataIndex: 'transportNo',
          align: 'center',
          scopedSlots: { customRender: 'transport' },
        },
        {
          title: '快递状态',
          dataIndex: 'transportStatus',
          align: 'center',
        },
        // {
        //   title: '签收日期',
        //   dataIndex: 'sendTime',
        //   align:'center'
        // },
        {
          title: '发货时间',
          dataIndex: 'sendTime',
          align: 'center',
        },
        {
          title: '发货人',
          dataIndex: 'sendUser',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '配件申请时间',
          dataIndex: 'applyTime',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
      ],
      loadData: (parameter) => {
        return getAccessoryOrderlist(Object.assign(parameter, this.queryParam))
      },
      time_list: '',
      showEntrepot: checkPermission('showEntrepot'),
      showRepertory: checkPermission('showRepertory'),
      sendOrder: checkPermission('sendOrder'),
      exportPartsOrder: checkPermission('partsOrder:export'),
      queryList: checkPermission('order:PartsOrderlist:query:list'),
      dateFormat: 'YYYY/MM/DD',
      // 字典为快递公司
      delivery_company: [],
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      dtoList: [],
      // 字典为订单状态,
      disable: false,
      sendTime: '',
      order_status: [],
      // 字典为快递状态
      delivery_status: [],
      // 字典为安装类型
      installTypes: [],
      List: [],
      // 企业名称
      selectCombox: [],
      getselectstoreList: [],
      dtoListtab: {},
      queryParam: {},
      labelCol: { xs: { span: 24 }, sm: { span: 5 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
    }
  },
  // destroyed () {
  //   document.body.removeEventListener('keyup', e => {})
  // },
  async created() {
    let dictTypes = ['install_type', 'time_type', 'delivery_company', 'delivery_status', 'order_status']
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      //console.log(res)
      this.installTypes = res.install_type
      this.time_type = res.time_type
      this.delivery_company = res.delivery_company
      this.delivery_status = res.delivery_status
      this.order_status = res.order_status
    })

    this.getselectstoreList = []
    await getselectstore().then((res) => {
      if (res.code === 0) {
        this.getselectstoreList = res.rows
        // console.log(res.rows)
      } else {
        this.$message.error(res.msg)
      }
    })

    await getselectAllProvince().then((res) => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })

    // 企业名称
    this.selectCombox = []
    // isAuthority 1   数据隔离
    await getselectCombox({ isAuthority: 1 }).then((res) => {
      if (res.code === 0) {
        this.selectCombox = res.data
        // console.log(this.selectCombox)
      } else {
        this.$message.error(res.msg)
      }
    })
    if (!this.showEntrepot) {
      for (let i in this.columns) {
        if (this.columns[i].title == '发货仓库') {
          this.columns.splice(i, 1)
        }
      }
    }
  },
  methods: {
    getCurrentData() {
      return new Date().toLocaleDateString()
    },
    moment,
    exceptExcel() {
      var str = process.env.VUE_APP_API_BASE_URL + '/order/AccessoryOrder/export?pageNum=1&pageSize=10'
      console.log(this.queryParam)
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      console.log(str)
      debugger
      window.open(str)
      // getAccessoryExcept(this.queryParam).then(res=>{
      //   console.log(res)
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   console.log(href)
      //   a.href = href
      //   let fileName = '配件订单'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    empty() {
      this.queryParam = {}
      this.queryParam.searchBeginTime = ''
      this.queryParam.searchEndTime = ''
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    gettransport(record) {
      getTransportInfo({ transportNo: record.transportNo, transportCode: record.transportCode }).then((res) => {
        if (res.code === 0) {
          this.transportble = true
          this.transportInfo = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    inventoryView(record) {
      getAccessoryNumber({ storeId: record.repositoryId, accessoryId: record.accessoryId }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.$message.success(`库存为${res.data}`)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    goodsDeliver(record) {
      // console.log(this.$store.getters,this.$store.getters.nickname)
      this.formdelivergoods.resetFields()
      this.delivergoodsible = true
      this.time_list = ''
      if (record.sendTime) {
        this.sendTime = moment(record.sendTime, this.dateFormat)
      } else {
        this.sendTime = moment(new Date().toLocaleDateString(), this.dateFormat)
      }

      this.$nextTick(() => {
        if (record.isMain) {
          this.formdelivergoods.setFieldsValue({
            isMainbool: record.isMain == 0 ? false : true,
          })
        }
        this.formdelivergoods.setFieldsValue(
          pick(record, 'id', 'orderId', 'transportCode', 'transportNo', 'sendUser', 'receiveUser', 'remark')
        )
        if (!record.receiveUser) {
          setTimeout(() => {
            this.formdelivergoods.setFieldsValue({
              receiveUser: record.clientName,
            })
          }, 100)
        }
        if (!record.sendUser) {
          setTimeout(() => {
            this.formdelivergoods.setFieldsValue({
              sendUser: this.$store.getters.nickname,
            })
          }, 100)
        }
      })
    },
    onChangeinfo() {
      this.showh = !this.showh
    },
    cancelAccessories() {
      this.time_list = ''
    },

    onChangeT(date, dateString) {
      this.parts.deliveryTime = dateString
    },

    onChangesendTime(date, dateString) {
      this.parts.sendTime = dateString
    },
    checkboxchange(e) {
      this.parts.isMain = e.target.checked ? '1' : '0'
      // console.log(this.parts.isMain)
    },
    fittingEdit(record) {
      console.log(record)
      this.formaccessories.resetFields()
      this.disable = true
      // this.showh = true
      this.parts = record
      this.time_list = ''
      if (record.sendTime) {
        this.time_list = moment(record.sendTime, this.dateFormat)
      }
      if (record.transportNo) {
        this.showh = true
      } else {
        this.showh = false
      }
      let totalAmount = record.totalAmount
      let accessoryNum = record.accessoryNum
      setTimeout(() => {
        this.formaccessories.setFieldsValue({
          price: (totalAmount - 0) / (accessoryNum - 0),
        })
      }, 100)
      this.$nextTick(() => {
        this.formaccessories.setFieldsValue(
          pick(
            record,
            'id',
            'orderAccessoryId',
            'accessoryName',
            'accessoryId',
            'repositoryId',
            'orderId',
            'transportId',
            'storeName',
            'transportId',
            'accessoryNum',
            'totalAmount',
            'transportCode',
            'transportNo',
            'sendUser',
            'receiveUser',
            'remark'
          )
        )
      })
      if (record.price) {
        record.totalAmount = record.accessoryNum * record.price
      } else {
        return 0
      }
    },
    detailsView(record) {
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(record.orderId, '', 0)
      })
    },
    onChangeaccessories(date, dateString) {
      this.parts.deliveryTimeReturn = dateString
    },
    addaccessoriesReturn() {
      this.formaccessoriesReturn.validateFields((err, values) => {
        values.deliveryTime = this.parts.deliveryTimeReturn
        console.log(values)
        if (!err) {
          this.accessoriesitem = ''
          getreturnOrderAccessory(values).then((res) => {
            if (res.code === 0) {
              this.accessoriesReturnidle = false
              this.$message.success('退回成功')
              this.$refs.table.refresh()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },
    partsReturn(record) {
      this.accessoriesReturnidle = true
      this.formaccessoriesReturn.resetFields()
      this.accessoriesitem = ''
      setTimeout(() => {
        this.formaccessoriesReturn.setFieldsValue({
          orderAccessoryId: record.id,
        })
      }, 100)
      console.log(record)
    },
    partsObsolete(id) {
      getinvalidOrderAccessory({ orderAccessoryId: id }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.$message.success('作废成功')
          this.$refs.table.refresh()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    adddelivergoods() {
      this.formdelivergoods.validateFields((err, values) => {
        values.sendTime = this.parts.sendTime
        values.isMain = values.isMainbool ? 1 : 0
        // this.parts.isMain
        console.log(values)
        if (!err) {
          this.delivergoodsible = false
          this.sendTime = ''
          getdeliverGoods(values).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$refs.table.refresh()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },
    addAccessories() {
      this.formaccessories.validateFields((err, values) => {
        values.deliveryTime = this.parts.deliveryTime
        values.orderAccessoryId = values.id
        console.log(values)
        if (!err) {
          this.disable = false
          this.time_list = ''
          addOrderAccessory(values).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$refs.table.refresh()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },

    accessoryChange() {},
    async accessoryNumChange(e) {
      if (this.parts.price) {
        this.parts.totalAmount = this.parts.accessoryNum * this.parts.price
      } else {
        return 0
      }
      if (this.parts.accessoryId && this.parts.enterpriseId && e.target.value) {
        /* this.queryEnterpriseStock= [];*/
        await getqueryEnterpriseStock({
          accessoryId: this.parts.accessoryId,
          enterpriseId: this.parts.enterpriseId,
          useNum: e.target.value,
        }).then((res) => {
          if (res.code === 0) {
            this.queryEnterpriseStock = res.data
            /* console.log(res)*/
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请选择配件，企业名称，配件数量不能为空')
      }
    },
    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      // this.queryParam.countyId=''
      // this.queryParam.clientAddress=''
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangerangepicker(date, dateString) {
      this.queryParam.searchBeginTime = dateString[0]
      this.queryParam.searchEndTime = dateString[1]
      // // console.log(this.dtoListtab.timeType)
      // this.dtoList.push(this.dtoListtab)
      // console.log(this.dtoList)
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped>
/deep/ .ant-steps-dot .ant-steps-item-content {
  width: 398px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
